exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 993px) {\n  .subscription-bar-visible {\n    margin-top: 30px !important;\n  }\n  .subscription-bar-visible #m_aside_left {\n    margin-top: 15px !important;\n  }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/app/app.component.less
// module id = ../../../../../src/app/app.component.less
// module chunks = main